import { z } from 'zod';
/**
 * Teams (TS-1861): named groups of members. A member may be in several teams, and a team may
 * have several leads (`isLead`): a label for now, it grants nothing. Reading needs
 * `team.read`, changing `team.manage`.
 */
export const teamNameSchema = z.string().trim().min(1).max(100);
export const teamInputSchema = z.object({ name: teamNameSchema });
export const teamMemberInputSchema = z.object({
    userId: z.uuid(),
    isLead: z.boolean().default(false),
});
/** Creating a team may name its first members, so a new team is complete in one call. */
export const teamCreateSchema = teamInputSchema.extend({
    members: z
        .array(teamMemberInputSchema)
        .max(500)
        .refine((ms) => new Set(ms.map((m) => m.userId)).size === ms.length, 'Each person once')
        .default([]),
});
export const teamMemberPatchSchema = z.object({ isLead: z.boolean() });
export const teamMemberSchema = z.object({
    userId: z.uuid(),
    name: z.string(),
    email: z.string(),
    isLead: z.boolean(),
});
export const teamSchema = z.object({
    id: z.uuid(),
    name: z.string(),
    /** Leads first, then by name. */
    members: z.array(teamMemberSchema),
    createdAt: z.iso.datetime({ offset: true }),
    updatedAt: z.iso.datetime({ offset: true }),
});
/** Move a member's projects and open tasks to another member (admins, or a lead of both). */
export const workReassignSchema = z.object({ toUserId: z.uuid() });
export const workReassignResultSchema = z.object({
    projects: z.number().int(),
    tasks: z.number().int(),
});
//# sourceMappingURL=teams.js.map